import { Routes } from '@angular/router';

import { advaniaServicesSegments } from '@advania-cosoftware/wolf-router';

export const networkManagementRoutes: Routes = [
    {
        path: advaniaServicesSegments.lanManagementCiscoMeraki,
        loadComponent: () =>
            import('./pages/lan-management-cisco-meraki-page/lan-management-cisco-meraki.page').then(
                (m) => m.LanManagementCiscoMerakiPage,
            ),
    },
    {
        path: advaniaServicesSegments.lanManagementCiscoClassic,
        loadComponent: () =>
            import('./pages/lan-management-cisco-classic-page/lan-management-cisco-classic.page').then(
                (m) => m.LanManagementCiscoClassicPage,
            ),
    },
    {
        path: advaniaServicesSegments.wifiManagementCiscoMeraki,
        loadComponent: () =>
            import('./pages/wifi-management-cisco-meraki-page/wifi-management-cisco-meraki.page').then(
                (m) => m.WifiManagementCiscoMerakiPage,
            ),
    },
    {
        path: advaniaServicesSegments.wlanManagementCiscoClassic,
        loadComponent: () =>
            import('./pages/wlan-management-cisco-classic-page/wlan-management-cisco-classic.page').then(
                (m) => m.WlanManagementCiscoClassicPage,
            ),
    },
    {
        path: advaniaServicesSegments.wanManagement,
        loadComponent: () => import('./pages/wan-management-page/wan-management.page').then((m) => m.WanManagementPage),
    },
];
